module.exports = __webpack_public_path__ + "static/media/sidebar-4.80d4a4e5.jpg";